import React from "react"
import Img from "gatsby-image"
import { Paper } from "@material-ui/core"

const Item = ({ photo }) => {
  return (
    <Paper>
      <Img fluid={photo.fluid} alt={photo.alt} />
    </Paper>
  )
}

export default Item
